<template>
  <breadCrumbs title="ICO Icons" main="Icons" title1="ICO Icons" />
  <div class="container-fluid text-start">
    <div class="row">
      <div class="col-sm-12" v-for="(item, index) in menu" :key="index">
        <div class="card">
          <div class="card-header pb-0">
            <h3 class="m-b-0">Abstract</h3><span>New</span>
          </div>
          <div class="card-body">
            <div class="row icon-lists">
              <div class="col-sm-6 col-md-6 col-lg-4" v-for="(index) in item.value" :key="index"
                v-on:click="icon_bar(index)">
                <i class="icofont" :class="'icofont-' + index"></i>{{ index }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="icon-hover-bottom p-fixed fa-fa-icon-show-div" :class="{ 'opecity-0': !icon_bar_status }"
    :style="[icon_bar_status ? { 'display': 'block' } : { 'display': 'none' }]">
    <div class="container-fluid">
      <div class="row">
        <div class="icon-popup">
          <div class="close-icon" v-on:click="close_icon_bar"><i class="icofont icofont-close"></i></div>
          <div class="icon-first"><i class="fa-2x" :class="[select_icon.class]"></i></div>
          <div class="icon-class">
            <label class="icon-title">Class</label><span>icon-drupal</span>
          </div>
          <div class="icon-last icon-last">
            <label class="icon-title">Markup</label>
            <div class="form-inline">
              <div class="form-group">
                <input class="inp-val form-control m-r-10" type="text" ref="text" :value="select_icon.tag"
                  readonly="readonly">
                <button class="btn btn-primary notification" v-on:click="copy_icon">Copy text</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import data from '../../data/icoData.json'
export default {
  data() {
    return {
      icon_bar_status: false, select_icon: { class: '', tag: '' },
      menu: [
        { name: "Abstract", value: data.abstract },
        { name: "Animal", value: data.animal },
        { name: "Brand", value: data.brand },
        { name: "Business", value: data.business },
        { name: "Chart", value: data.chart },
        { name: "construction", value: data.construction },
        { name: "Currency", value: data.currency },
        { name: "device", value: data.device },
        { name: "Directional", value: data.directional },
        { name: "Education", value: data.eduction },
        { name: "Emotion", value: data.emotion },
        { name: "File", value: data.file },
        { name: "Food", value: data.food },
        { name: "Kids", value: data.kids },
        { name: "law", value: data.law },
        { name: "Mathematical", value: data.mathematical },
        { name: "medical", value: data.medical },
        { name: "Mobile Ui", value: data.mobileui },
        { name: "Multimedia", value: data.multimedia },
        { name: "payment", value: data.payment },
        { name: "Person", value: data.person },
        { name: "Search", value: data.search },
        { name: "Social", value: data.social },
        { name: "Sport", value: data.sport },
        { name: "Text Editor", value: data.texteditor },
        { name: "Transport", value: data.transport },
        { name: "Travel", value: data.travel },
        { name: "Weather", value: data.weather },
        { name: "Web Application", value: data.webapplication },
      ]
    };
  },
  methods: {
    icon_bar(icon) {
      this.select_icon.class = 'icofont icofont-' + icon;
      this.select_icon.tag = '<i class="icofont icofont-' + icon + '"></i>';
      this.icon_bar_status = true;
    },
    close_icon_bar() {
      this.icon_bar_status = false;
    },
    copy_icon() {
      this.$refs.text.select();
      document.execCommand('copy');
      this.$toast.show('Code Copied to Clipboard', {
        theme: 'outline', position: 'bottom-right', closeOnSwipe: true, type: 'default', duration: 2000, className: 'alert-copy', action: {
          icon: 'times',
          onClick: (e, toastObject) => { toastObject.goAway(0); }
        }
      });
    }
  }
};
</script>